import script from "./PingLunHuiKuiPage.vue?vue&type=script&setup=true&lang=js"
export * from "./PingLunHuiKuiPage.vue?vue&type=script&setup=true&lang=js"

import "./PingLunHuiKuiPage.vue?vue&type=style&index=0&id=9726e720&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-9726e720"]])

export default __exports__